import { css, LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let LoadingAnimation = class extends LitElement {
  render() {
    return html`
      <div>
        <svg class="spinner" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-loader-2"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>
      </div>
    `;
  }
};
LoadingAnimation.styles = css`
    /* SPINNER STYLES */
    .spinner {
      animation: spin 1s linear infinite;
    }

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    }

    @keyframes spin {
      from {
          transform:rotate(0deg);
      }
      to {
          transform:rotate(360deg);
      }
    }
  `;
LoadingAnimation = __decorateClass([
  customElement("loading-animation")
], LoadingAnimation);
export {
  LoadingAnimation
};
